module.exports = __webpack_public_path__ + "img/play-button-white.52fb425c.svg";